const translations = {
  "en": {
    "Add To Your Watchlist!": "Add To Your Watchlist!",
    "No search results yet": "No search results yet",
    "Search for tokens to track, your future self will thank you for keeping an eye on the right ones 👀": "Search for tokens to track, your future self will thank you for keeping an eye on the right ones 👀"
  },
  "zh-tw": {
    "Add To Your Watchlist!": "立即新增至關注列表！",
    "No search results yet": "尚無搜尋結果",
    "Search for tokens to track, your future self will thank you for keeping an eye on the right ones 👀": "搜尋並追蹤你看好的代幣，未來的你會感謝自己盯緊了對的標的 👀"
  }
};

export default translations;
